import React from 'react'

import img1 from './images/icons/about us icons/  (1).png'
import img2 from './images/icons/about us icons/  (2).png'
import img3 from './images/icons/about us icons/  (3).png'
import img4 from './images/icons/about us icons/  (4).png'
import img5 from './images/icons/about us icons/  (5).png'
import img6 from './images/icons/about us icons/  (6).png'
import img7 from './images/icons/about us icons/  (7).png'
import img8 from './images/icons/about us icons/  (8).png'
import img9 from './images/icons/about us icons/  (9).png'
import img10 from './images/icons/about us icons/  (10).png'
import img12 from './images/icons/about us icons/  (12).png'
import img13 from './images/icons/about us icons/  (13).png'
import img14 from './images/icons/about us icons/  (14).png'
import img15 from './images/icons/about us icons/  (15).png'
import img16 from './images/icons/about us icons/  (23).png'
import img17 from './images/icons/about us icons/  (17).png'
import img18 from './images/icons/about us icons/  (18).png'
import img19 from './images/icons/about us icons/  (19).png'
import img20 from './images/icons/about us icons/  (20).png'
import img21 from './images/icons/about us icons/  (21).png'
import img22 from './images/icons/about us icons/  (22).png'
import img23 from './images/icons/about us icons/  (23).png'
import img24 from './images/icons/about us icons/(24).png'
import img11 from './images/icons/about us icons/  (11).png'

import Component_Heading from '../component/Component_Heading'

export default function Futuristic_tech() {
  return (
    <>
    <div className="BackGroundColor">
    <div className="main-futuristic-tech">
        <Component_Heading heading="INNOVATIVE TECHNOLOGY TAILORED TO EVERY BUSINESS NEED" para="Our team leverages advanced, futuristic digital solutions crafted specifically around your unique business goals."/>
        </div>
    <div className="container sub-future">
        <div className="row row-cols-16 futuristis-row">
            <div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img1} alt="" />
                </div>
            </div>
            <div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img2} alt="" />
                </div>
            </div>
            <div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img3} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img4} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img5} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img6} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img7} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img8} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img9} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img10} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img11} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img12} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img13} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img14} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img15} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img16} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img17} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img18} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img19} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img20} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img21} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img22} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img23} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img24} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img16} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img17} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img1} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img5} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img9} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img4} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img12} alt="" />
                </div>
            </div><div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img13} alt="" />
                </div>
            </div>
            <div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img17} alt="" />
                </div>
            </div>
            <div className="col futuristic-col">
                <div className="iconImg">
                    <img src={img7} alt="" />
                </div>
            </div>

        </div>
    </div>
    </div> 
    
      
    </>
  )
}
